import { render, staticRenderFns } from "./NewBidderInAdjudgeForm.vue?vue&type=template&id=43684381&"
import script from "./NewBidderInAdjudgeForm.vue?vue&type=script&lang=js&"
export * from "./NewBidderInAdjudgeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43684381')) {
      api.createRecord('43684381', component.options)
    } else {
      api.reload('43684381', component.options)
    }
    module.hot.accept("./NewBidderInAdjudgeForm.vue?vue&type=template&id=43684381&", function () {
      api.rerender('43684381', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/NewBidderInAdjudgeForm.vue"
export default component.exports